import Container = PIXI.Container;
import { createPixiText } from '../../../Utils/Utils';
import Rectangle = PIXI.Rectangle;

export class NewsTab extends Container {
    constructor(width: number, height: number, header: string, text: string, date: number) {
        super();

        const headerText = createPixiText(
            header,
            new Rectangle(0, 0, width * 0.75, width * 0.2),
            'Baloo',
            24,
            24,
            0xff6600
        );
        headerText.anchor.x = 0;
        const newsText = createPixiText(
            text,
            new Rectangle(0, 0, width * 0.9, width * 0.2),
            'Baloo',
            19,
            19,
            0x006eba,
            'left'
        );
        newsText.anchor.set(0, 0);
        const dateString = date.toString();
        const dateText = createPixiText(
            dateString.substring(6, 8) +
                '.' +
                dateString.substring(4, 6) +
                '.' +
                dateString.substring(0, 4),
            new Rectangle(0, 0, width * 0.5, width * 0.2),
            'Baloo',
            24,
            24,
            0x006eba
        );
        dateText.anchor.x = 0;

        const rect = PIXI.utils.TextureCache['mapui/leaderboard-playertag-bg'];
        const bg = new PIXI.mesh.NineSlicePlane(rect, 10, 10, 10, 20);
        // adjust for weird position caused by rect
        bg.width = width * 0.95;
        bg.height = height * 0.4;
        bg.pivot.x = bg.width / 2;
        bg.pivot.y = bg.height / 2;
        headerText.x = -width * 0.45;
        headerText.y = bg.y - bg.height / 2 + headerText.height / 2 + 10;
        dateText.x = width * 0.23;
        dateText.y = headerText.y;
        newsText.x = -width * 0.43;
        newsText.y = headerText.y + headerText.height * 0.8;

        //@ts-ignore
        this.addChild(bg, headerText, newsText, dateText);
    }
}
